var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221",
    transform: "translate(-3504 -856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(3506.426 859.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M6.86,13.458a.62.62,0,0,1-.877,0l-3.5-3.5a.93.93,0,0,1,0-1.316L2.919,8.2a.93.93,0,0,1,1.316,0l2.187,2.187L12.33,4.479a.93.93,0,0,1,1.316,0l.439.439a.93.93,0,0,1,0,1.316Z",
    transform: "translate(-2.208 -4.207)",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.d7c6bcc4c6d001d6c71f87b07c6e99e1.svg";
export { ForwardRef as ReactComponent };